export default __webpack_public_path__ + "static/media/Standardization_Documentation_KADAP.46d983c2.pdf";